/* eslint-disable react/jsx-no-bind */
import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Divider, Grid } from '@material-ui/core';
import FiberNewIcon from '@material-ui/icons/FiberNew';

import IconButton from '@material-ui/core/IconButton';
import PrintIcon from '@material-ui/icons/Print';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import CompareIcon from '@material-ui/icons/Compare';

import Card from 'src/components/sharedComponents/Card/Card';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import CardFooter from 'src/components/sharedComponents/Card/CardFooter';
import CardRotateEffect from 'src/components/insigth/CardRotateEffect';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import ValueMapAddVehicle from 'src/components/insigth/ValueMapAddVehicle';
import CardMapValue from 'src/components/insigth/CardMapValue';
import CardMapAttributes from 'src/components/insigth/CardMapAttributes';
import SaveMapValueModal from 'src/components/insigth/MapValueModalSave';
import SelectorValueMaps from 'src/components/insigth/SelectorValueMaps';
import CompareMapsValues from 'src/components/insigth/CompareMapsValues';
import MapValueCardGraph from 'src/components/insigth/MapValueCardGraph';
import MapsValuesPrint from 'src/components/insigth/MapsValuesPrint';
import ValueMapAttributes from 'src/components/insigth/MapValueAttributes';
import { Context } from 'src/context/Contex';
import { minPermisos, permitsList } from '../../../constants/permits';

import { style } from './styles';

const ValueMapDetailPage = ({
  open,
  save,
  loading,
  mapValue,
  vehicles,
  stateEdit,
  attributes,
  newVehicle,
  handleClose,
  addToMapValue,
  totalMapsValue = [],
  handleOpenModal,
  handleSaveImage,
  handleCreateCard,
  handleRemoveCard,
  onChangeMapValue,
  handleSelectForm,
  dataSetGenerator,
  onChangeAddPram,
  handleDeleteCard,
  vehiclesBySegment,
  handleEditVehicle,
  onChangeAttribute,
  handleAddAttribute,
  handleSaveValueMap,
  handleOpenModalSave,
  handleSelectMapValue,
  handleDeleteValueMap,
  handleUpdateMapValue,
  handleEditAttribute,
  handleDeleteAttribute,
  handleCreateAttribute,
  res,
}) => {
  const useStyles = makeStyles(style);
  const classes = useStyles();
  const mapValueLider = mapValue;
  const [compare, setOpen] = React.useState(false);
  const [print, setPrint] = React.useState(false);
  const [openAttributes, setOpenAttributes] = React.useState(false);
  const { permisos } = useContext(Context);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseCompare = () => {
    setOpen(false);
    setPrint(false);
    setOpenAttributes(false);
  };

  const handleOpenAttributes = () => {
    setOpenAttributes(true);
  };

  function functionPrint() {
    const el = document.getElementById('app');
    const modal = document.getElementById('modal-print');
    const btn = document.getElementById('buttons-print');
    // el.remove()
    el.classList.add(classes.noPrint);
    btn.classList.add(classes.noPrint);
    modal.classList.add(classes.modalPrint);

    window.print();
    window.addEventListener('afterprint', () => {
      el.classList.remove(classes.noPrint);
      btn.classList.remove(classes.noPrint);
    });
  }

  const hidden = compare || print ? { display: 'none' } : null;
  return (
    <>
      {compare && (
        <CompareMapsValues
          id="modal-print"
          classes={classes}
          compare={compare}
          mapValue={mapValue}
          functionPrint={functionPrint}
          totalMapsValue={totalMapsValue}
          dataSetGenerator={dataSetGenerator}
          handleCloseCompare={handleCloseCompare}
        />
      )}
      {print && (
        <MapsValuesPrint
          id="modal-print"
          classes={classes}
          compare={print}
          mapValue={mapValue}
          functionPrint={functionPrint}
          totalMapsValue={totalMapsValue}
          dataSetGenerator={dataSetGenerator}
          handleCloseCompare={handleCloseCompare}
        />
      )}
      {open && (
        <ValueMapAddVehicle
          open={open}
          stateEdit={stateEdit}
          newVehicle={newVehicle}
          attributes={attributes}
          handleSelectForm={handleSelectForm}
          handleOpenModal={handleOpenModal}
          onChangeAddPram={onChangeAddPram}
          handleSaveImage={handleSaveImage}
          handleCreateCard={handleCreateCard}
          vehiclesBySegment={vehiclesBySegment}
          handleDeleteCard={handleDeleteCard}
          {...res}
        />
      )}
      {openAttributes && (
        <ValueMapAttributes
          handleUpdateMapValue={handleUpdateMapValue}
          handleDeleteAttribute={handleDeleteAttribute}
          handleCreateAttribute={handleCreateAttribute}
          handleEditAttribute={handleEditAttribute}
          handleAddAttribute={handleAddAttribute}
          onChangeAttribute={onChangeAttribute}
          handleClose={handleCloseCompare}
          attributes={attributes}
          open={openAttributes}
          classes={classes}
        />
      )}
      <SaveMapValueModal
        save={save}
        mapValue={mapValue}
        handleClose={handleClose}
        onChangeMapValue={onChangeMapValue}
        handleSaveValueMap={handleSaveValueMap}
      />
      <div style={hidden}>
        <Card>
          <CardHeader color="customAuteco">
            <h4 className={classes.cardTitleWhite}>Mapas de Valor</h4>
          </CardHeader>
          <CardBody className={classes.container}>
            <p>Mapas de valor disponibles</p>
            <section style={{ display: 'flex' }}>
              <div style={{ width: '100%', paddingRight: '20px' }}>
                <SelectorValueMaps
                  mapValue={mapValue}
                  stateEdit={stateEdit}
                  totalMapsValue={totalMapsValue}
                  handleSelectMapValue={handleSelectMapValue}
                />
              </div>
              <IconButton
                aria-label="comparar"
                component="span"
                onClick={() => handleClickOpen()}
              >
                <CompareIcon style={{ color: 'blue' }} />
              </IconButton>
              <IconButton
                aria-label="guardar"
                component="span"
                onClick={() => handleOpenModalSave()}
              >
                <SaveIcon style={{ color: 'green' }} />
              </IconButton>
              <IconButton
                aria-label="eliminar"
                component="span"
                onClick={() => handleDeleteValueMap()}
              >
                <DeleteIcon style={{ color: 'red' }} />
              </IconButton>
              <IconButton
                aria-label="imprimir"
                component="span"
                onClick={() => setPrint(!print)}
              >
                <PrintIcon />
              </IconButton>
            </section>
          </CardBody>
        </Card>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={4} lg={3}>
            <Card className={classes.textCenter}>
              <CardHeader color="customAuteco">
                <h4 className={classes.cardTitleWhite}>Vehículo</h4>
                <div>
                  <Button
                    fullWidth
                    color="pinterest"
                    disabled={loading}
                    onClick={() => handleUpdateMapValue(false)}
                  >
                    <FiberNewIcon />
                    Actualizar Mapa
                  </Button>
                </div>
                {permisos[permitsList.VALUE_MAP] === minPermisos.ADMINISTATIVO
                  ? (
                    <div>
                      <Button
                        fullWidth
                        color="pinterest"
                        disabled={loading}
                        onClick={() => handleOpenAttributes()}
                      >
                        <FiberNewIcon />
                        Actualizar Atributos
                      </Button>
                    </div>
                  )
                  : null}
              </CardHeader>
              <CardBody className={classes.container}>
                {vehicles.map((value, index) => (
                  <div key={value.id}>
                    <CardRotateEffect
                      {...value}
                      index={index}
                      stateEdit={stateEdit}
                      handleOpenModal={handleOpenModal}
                      handleEditVehicle={handleEditVehicle}
                      addToMapValue={() => addToMapValue(value)}
                    />
                    <Divider />
                  </div>
                ))}
              </CardBody>
              <CardFooter className={classes.textMuted}>
                <Button
                  disabled={stateEdit}
                  onClick={() => handleOpenModal({ open: true, isEdit: false })}
                  link
                >
                  <FiberNewIcon />
                  {' '}
                  Crear Vehículo
                </Button>
              </CardFooter>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={9}>
            <Card>
              <CardHeader color="customAuteco">
                {' '}
                <h4 className={classes.cardTitleWhite}>Mapa de Valor</h4>
              </CardHeader>
              <CardBody className={classes.container}>
                <section
                  style={{ display: 'flex', justifyContent: 'flex-start' }}
                >
                  <CardMapAttributes attributes={attributes} />
                  {mapValueLider.foto.map((value, index) => (
                    <div key={value?.id} style={{ margin: '2px' }}>
                      <CardMapValue
                        result={mapValueLider.result}
                        stateEdit={stateEdit}
                        lider={mapValue.foto}
                        {...value}
                        attributes={attributes}
                        handleRemoveCard={() => handleRemoveCard({ value, index })}
                      />
                    </div>
                  ))}
                </section>
              </CardBody>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <MapValueCardGraph
              height={80}
              width={100}
              classes={classes}
              title="Unidades Mes"
              data={dataSetGenerator(mapValue, 'unidades')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <MapValueCardGraph
              height={80}
              width={100}
              classes={classes}
              title="Unidades proyectadas"
              data={dataSetGenerator(mapValue, 'proyectado')}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default ValueMapDetailPage;
